<template>
    <touchpoint-overview-row class="info-row-header">
        <template slot="left" v-if="displaySource">
            <div class="info-row-header-cell d-flex">
                <touchpoint-overview-icon-circle class="info-circle mr-2" color="blue"/>
                <span class="info-row-header-text">{{resource('TouchpointStatistics_Header_PreviousTouchpoint')}}</span>
            </div>
        </template>

        <template slot="center" v-if="displaySelected">
            <div class="info-row-header-cell">
                <touchpoint-overview-icon-magic />
                
                <br />
                
                <span class="info-row-header-text">{{resource('TouchpointStatistics_Header_SelectedNumber')}}</span>
            </div>
        </template>

        <template slot="right" v-if="displayDestination">
            <div class="info-row-header-cell d-flex flex-row-reverse">
                <touchpoint-overview-icon-circle class="info-circle" color="green"/>
                <span class="info-row-header-text mr-2">{{resource('TouchpointStatistics_Header_ArrivedAtTouchpoint')}}</span>
            </div>
        </template>
    </touchpoint-overview-row>
</template>

<script>
    import resourceMixin from "@core/Util/Mixins/resources";
    
    import TouchpointOverviewIconCircle from "../TouchpointOverviewIconCircle.vue";
    import TouchpointOverviewIconMagic from "../TouchpointOverviewIconMagic.vue";
    import TouchpointOverviewRow from "../TouchpointOverviewRow.vue";
    
    export default {
        name: 'touchpoint-statistics-info-header',
        components: {
            TouchpointOverviewIconCircle,
            TouchpointOverviewIconMagic,
            TouchpointOverviewRow
        },
        mixins: [resourceMixin],
        props: {
            displaySource: Boolean,
            displaySelected: Boolean,
            displayDestination: Boolean
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/touchpoint-statistics-info-header.scss";
</style>